import utils from '@eitje/utils'
import {EitjeButton} from '../components'

export const SubmitButton = ({ref, onClick, isGreyedOut, popoutTitle, className, disabled, ...otherButtonProps}) => {
	return (
		<EitjeButton
			ref={ref}
			className={utils.makeCns('submit-button', className)}
			onClick={onClick}
			baseColor={isGreyedOut ? 'grey' : 'blue'}
			data-intercom-target="form-submit-button"
			disabled={disabled}
			popoutTitle={popoutTitle}
			t="common.submit"
			colorSet="solid"
			iconLeft="checked"
			{...otherButtonProps}
		/>
	)
}
